export default {
    repeats: [],
    upcomingRepeats: [],
    activeRepeat: {},
    manageRepeatDialog: false,
    deleteRepeatDialog: false,
    upcomingRepeatsDialog: false
}
